import { usePathname } from 'next/navigation'
import Badge from 'react-bootstrap/Badge'

import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { RelatedType } from '@/types/page'

import styles from './NavigationPanel.module.scss'
import CardButtonsTypeahead from './TagsTypeahead/RelatedTypeahead'

type Props = {
  related: RelatedType[]
  title: string
}

const NavigationPanelRelated = ({ related, title }: Props) => {
  const pathname = usePathname()

  if (related.length === 0) {
    return null
  }

  return (
    <div>
      <div className={styles.navigationTitle}>{title}</div>
      <div className={styles.tags}>
        {related.slice(0, 6).map(({ count, href, value }) => (
          <LinkHelper
            block
            ellipsis
            href={href || '#'}
            key={href}
            primary={href === pathname}
            scroll={false}
            title={value}
          >
            <span className={styles.label}>{value}</span>
            <Badge bg='light' className='text-dark'>
              {count >= 1000 ? `${Math.floor(count / 100) / 10}K` : count}
            </Badge>
          </LinkHelper>
        ))}
      </div>
      <CardButtonsTypeahead related={related} title={title} />
    </div>
  )
}

export default NavigationPanelRelated
